export default {"src":"/_next/static/media/protonmail.f1b8eb72.svg","height":397,"width":2500,"blurWidth":0,"blurHeight":0};